/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IConsultationRequestV2Schema {
  /** Email клиента **/
  email?: string;
  /** Сервис, из которого поступил запрос на консультацию **/
  origin: EOrigin;
  /** Телефон клиента **/
  phone?: string;
  /** Что хотите узнать **/
  question: string;
  /** Откуда поступила заявка (на русском) **/
  sentFrom: string;
}

export enum EOrigin {
  /** Циан.Сделка **/
  'E2eDeal' = 'e2eDeal',
  /** Юридическая проверка недвижимости **/
  'LegalCheck' = 'legalCheck',
  /** Циан.Ипотека для профи **/
  'Mortgage' = 'mortgage',
  /** Сделка с Новостройками **/
  'NewbuildingBroker' = 'newbuildingBroker',
  /** Заработай с ЦИАН **/
  'PartnerRewards' = 'partnerRewards',
}
